<template>
	<Slides :slides="slides" class="center-content" />
</template>

<script>
import { $src } from '@/lib/utils'

import Slides from './Slides.vue'

export default {
	name: 'SlidesERGs',
	components: {
		Slides,
	},
	data: () => ({
		slides: [
				{
					body: `<img src="${$src('/assets/slides/erg/1.png')}" alt="ERG 1" />`
				},
				{
					body: `<img src="${$src('/assets/slides/erg/2.png')}" alt="ERG 2" />`
				},
				{
					body: `<img src="${$src('/assets/slides/erg/3.png')}" alt="ERG 3" />`
				},
				{
					body: `<img src="${$src('/assets/slides/erg/4.png')}" alt="ERG 4" />`
				},
				{
					body: `<img src="${$src('/assets/slides/erg/5.png')}" alt="ERG 5" />`
				},
			]
	})
}
</script>

<style scoped lang="scss">
</style>
